import { Stack } from "@mui/material";

import * as imgsImport from "../assets";
import { getFilesByPrefix } from "../assets/utils";
import images from "../constants/images";
import type { BuildObjects } from "../types/tokenValley";
import { Animation } from "./Animation";

const IconBlock = ({
  blockType,
  bigSize,
  shadow = false,
  buildAnimation,
}: {
  blockType: BuildObjects;
  bigSize?: boolean;
  shadow?: boolean;
  buildAnimation?: boolean;
}) => {
  const imagesBuild = imgsImport as Record<string, string>;
  const labAnimations = getFilesByPrefix(imagesBuild, "labImgUrl");
  const millAnimations = getFilesByPrefix(imagesBuild, "millImgUrl");
  const ovenAnimations = getFilesByPrefix(imagesBuild, "ovenImgUrl");
  const woodAnimations = getFilesByPrefix(imagesBuild, "woodImgUrl");
  const ironAnimations = getFilesByPrefix(imagesBuild, "ironImgUrl");
  const wheatAnimations = getFilesByPrefix(imagesBuild, "wheatImgUrl");
  const ranchAnimations = getFilesByPrefix(imagesBuild, "ranchImgUrl");
  const constrAnimations = getFilesByPrefix(imagesBuild, "constrImgUrl");
  const cellarAnimations = getFilesByPrefix(imagesBuild, "cellarImgUrl");
  const cheeseAnimations = getFilesByPrefix(imagesBuild, "cheeseImgUrl");
  const builderAnimations = getFilesByPrefix(imagesBuild, "builderImgUrl");

  if (buildAnimation) {
    return (
      <Animation
        urls={constrAnimations}
        loop
        shadow={shadow}
        duration={2200}
        width={57}
        height={52}
        wContainer={91.2}
        style={{
          marginTop: "-5px",
          marginLeft: "10px",
        }}
        sizeShadow={50}
        xShadow={10}
        yShadow={-5}
      />
    );
  }

  switch (blockType) {
    case "build/dairy_cellar":
      return (
        <Animation
          urls={cheeseAnimations}
          loop
          shadow={shadow}
          duration={2200}
          width={bigSize ? 82 : 57}
          height={bigSize ? 77 : 52}
          wContainer={bigSize ? 77 : 91.2}
          style={{
            marginTop: bigSize ? "28px" : "-3px",
            marginLeft: bigSize ? "0px" : "10px",
          }}
          sizeShadow={70}
          xShadow={0}
          yShadow={-5}
        />
      );
    case "build/builders_hut":
      return (
        <Animation
          urls={builderAnimations}
          loop
          shadow={shadow}
          duration={2200}
          width={bigSize ? 82 : 57}
          height={bigSize ? 77 : 52}
          wContainer={bigSize ? 77 : 92}
          style={{
            marginTop: bigSize ? "28px" : "-3px",
            marginLeft: bigSize ? "0px" : "6px",
          }}
          sizeShadow={60}
          xShadow={-2}
          yShadow={0}
        />
      );
    case "build/milk_barn":
      return (
        <Animation
          urls={cellarAnimations}
          loop
          shadow={shadow}
          duration={1100}
          width={bigSize ? 82 : 57}
          height={bigSize ? 77 : 52}
          wContainer={bigSize ? 77 : 91.2}
          style={{
            marginTop: bigSize ? "28px" : "0px",
            marginLeft: bigSize ? "0px" : "9px",
          }}
          sizeShadow={70}
          xShadow={-1}
          yShadow={-2}
        />
      );
    case "build/iron_mine":
      return (
        <Animation
          urls={ironAnimations}
          loop
          shadow={shadow}
          duration={2200}
          width={bigSize ? 82 : 57}
          height={bigSize ? 77 : 52}
          wContainer={bigSize ? 77 : 91.2}
          style={{
            marginTop: bigSize ? "28px" : "-5px",
            marginLeft: bigSize ? "0px" : "8px",
          }}
          sizeShadow={60}
          xShadow={-4}
          yShadow={-4}
        />
      );
    case "build/token_house":
      return (
        <Stack>
          <img
            alt="build"
            src={images.buildings.token_house}
            style={{
              width: bigSize ? 82 : 60,
              marginTop: bigSize ? 4 : -13,
              marginLeft: bigSize ? 0 : 5,
            }}
          />
          {shadow && (
            <img
              src={images.shadown}
              alt=""
              style={{
                zIndex: -1,
                width: "80%",
                position: "absolute",
                bottom: "0px",
                left: "-2px",
              }}
            />
          )}
        </Stack>
      );
    case "build/ranch":
      return (
        <Animation
          urls={ranchAnimations}
          loop
          shadow={shadow}
          duration={2200}
          width={bigSize ? 82 : 57}
          height={bigSize ? 77 : 52}
          wContainer={bigSize ? 77 : 91.2}
          style={{
            marginTop: bigSize ? "28px" : "0px",
            marginLeft: bigSize ? "0px" : "3px",
          }}
          sizeShadow={70}
          xShadow={-3}
          yShadow={-4}
        />
      );
    case "build/lumber_mill":
      return (
        <Animation
          urls={woodAnimations}
          loop
          shadow={shadow}
          duration={2200}
          width={bigSize ? 85 : 58}
          height={bigSize ? 77 : 52}
          wContainer={bigSize ? 80 : 93}
          style={{
            marginTop: bigSize ? "28px" : "2px",
            marginLeft: bigSize ? "0px" : "10px",
          }}
          sizeShadow={60}
          xShadow={0}
          yShadow={0}
        />
      );
    case "build/mill":
      return (
        <Animation
          urls={millAnimations}
          loop
          shadow={shadow}
          duration={2200}
          width={bigSize ? 72 : 50}
          height={bigSize ? 81 : 59}
          wContainer={bigSize ? 70 : 80}
          style={{
            marginTop: bigSize ? "20px" : "-12px",
            marginLeft: bigSize ? "0px" : "9px",
          }}
          sizeShadow={55}
          xShadow={5}
          yShadow={-2}
        />
      );
    case "build/bakery":
      return (
        <Animation
          urls={ovenAnimations}
          loop
          shadow={shadow}
          duration={3000}
          width={bigSize ? 72 : 50}
          height={bigSize ? 81 : 59}
          wContainer={bigSize ? 68 : 80}
          style={{
            marginTop: bigSize ? "15px" : "-10px",
            marginLeft: bigSize ? "0px" : "10px",
          }}
          sizeShadow={60}
          xShadow={3}
          yShadow={-4}
        />
      );
    case "build/farm":
      return (
        <Animation
          urls={wheatAnimations}
          loop
          shadow={shadow}
          duration={2000}
          width={bigSize ? 75 : 50}
          height={bigSize ? 68 : 45}
          wContainer={bigSize ? 70 : 80}
          style={{
            marginTop: bigSize ? "40px" : "5px",
            marginLeft: bigSize ? "0px" : "7px",
          }}
          sizeShadow={55}
          xShadow={-1}
          yShadow={2}
        />
      );
    case "build/lab":
      return (
        <Animation
          urls={labAnimations}
          loop
          shadow={shadow}
          duration={2000}
          width={bigSize ? 65 : 44}
          height={bigSize ? 67 : 45}
          wContainer={bigSize ? 61 : 70}
          style={{
            marginTop: bigSize ? "50px" : "3px",
            marginLeft: bigSize ? "5px" : "12px",
          }}
          sizeShadow={50}
          xShadow={2}
          yShadow={3}
        />
      );
    default:
      return null;
  }
};

export default IconBlock;
